import { forwardRef, useImperativeHandle } from 'react';

import { Modal, useModalDialog } from '@xemplo/modal-dialog';

import {
  AssignPayrollManagerModalProps,
  ModalDialogRef,
} from './assign-payroll-manager.types';
import { AssignPayrollManagerContent } from './assign-payroll-manager-content';

export const AssignPayrollManagerModal = forwardRef<
  ModalDialogRef,
  AssignPayrollManagerModalProps
>((props, ref) => {
  const modalDialog = useModalDialog({
    id: 'assign-payroll-manager-modal',
  });
  useImperativeHandle(ref, () => modalDialog, [modalDialog]);

  return (
    <Modal.Dialog {...modalDialog.dialogProps}>
      {modalDialog.isOpen && (
        <AssignPayrollManagerContent {...props} modalDialog={modalDialog} />
      )}
    </Modal.Dialog>
  );
});
